import { Component } from '@angular/core';
import { NgsRevealConfig } from 'ngx-scrollreveal';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [NgsRevealConfig],
})

export class AppComponent {
  title = 'dg-app';

  constructor(options: NgsRevealConfig) {
    options.duration = 1000;
    options.distance = '100px';
    options.easing = 'cubic-bezier(0.645, 0.045, 0.355, 1)';
    options.scale = 1;
    options.delay = 200;
  }
}